import { apiFetch } from "../Utility/api";

const parseApiResponse = async (response) => {
  const contentType = response.headers.get("content-type") || "";
  const data = contentType.includes("application/json")
    ? await response.json()
    : { error: await response.text() };
  if (!response.ok) {
    throw new Error(data?.error || `Request failed with status ${response.status}`);
  }
  return data;
};

export const scrapbookCategories = [
  "Growth",
  "First",
  "Family",
  "Health",
  "Holiday",
  "Favorite",
  "Funny Moment",
  "Monthly Snapshot",
  "Milestone",
];

export const emptyScrapbookForm = {
  title: "",
  entryDate: "",
  ageLabel: "",
  category: "Milestone",
  story: "",
  weightValue: "",
  weightUnit: "lb",
  lengthValue: "",
  lengthUnit: "in",
  headCircumferenceValue: "",
  headCircumferenceUnit: "in",
  clothingSize: "",
  diaperSize: "",
  favoriteToy: "",
  favoriteSong: "",
  newWords: "",
  newFoods: "",
  healthNotes: "",
  tags: "",
  isFeatured: false,
};

export const fetchScrapbookEntries = async () => {
  const response = await apiFetch("/scrapbook/entries");
  return parseApiResponse(response);
};

export const saveScrapbookEntry = async (form, files = [], editingId = null) => {
  const formData = new FormData();
  Object.entries(form).forEach(([key, value]) => {
    formData.append(key, value === true ? "true" : value || "");
  });
  Array.from(files || []).forEach((file) => {
    formData.append("images", file);
  });

  const response = await apiFetch(
    editingId ? `/scrapbook/entries/${editingId}` : "/scrapbook/entries",
    {
      method: editingId ? "PUT" : "POST",
      body: formData,
    }
  );
  return parseApiResponse(response);
};

export const deleteScrapbookEntry = async (entryId) => {
  const response = await apiFetch(`/scrapbook/entries/${entryId}`, {
    method: "DELETE",
  });
  return parseApiResponse(response);
};

export const deleteScrapbookImage = async (imageId) => {
  const response = await apiFetch(`/scrapbook/images/${imageId}`, {
    method: "DELETE",
  });
  return parseApiResponse(response);
};

export const entryHasGrowth = (entry) => (
  entry?.weightValue || entry?.lengthValue || entry?.headCircumferenceValue
);

export const getEntryCoverImage = (entry) => entry?.images?.[0]?.url || "";

export const formatMeasurement = (value, unit) => {
  if (value === null || value === undefined || value === "") return "";
  return `${value} ${unit || ""}`.trim();
};
